import React, { useState } from 'react'
import PropTypes from 'prop-types'

import {
  UNLOCK_BUTTON_FALLBACK_LABEL,
  PURCHASE_IN_FIELD_TOOLTIP
} from '@aytm/app/stats/page/sidebar/reports/lib/skipperGuidedReportsConst'

import Popup from '@aytm/lib/rfd-ui/components/basic/popup'

import style from '@aytm/app/stats/page/sidebar/reports/styles/ReportsPanel.module.scss'

// The row a gated control sits in, and the only surface its explanation can reach the user
// from: a disabled control reports no pointer events, so anything hung off the control itself is
// unreachable in the one state that has something to say. Popup gets trigger="none", so visibility
// is owned here (CodingCodebook.jsx). `className` carries the host's own layout classes, since the
// row is shared by the panel header and the report-settings flyout.
export const HintRow = ({ hint, className, children }) => {
  const [show, setShow] = useState(false)

  return (
    <div
      className={className ? `${style['beta-popup']} ${className}` : style['beta-popup']}
      onMouseOver={hint ? () => setShow(true) : null}
      onMouseOut={hint ? () => setShow(false) : null}
    >
      {hint && show ? (
        <Popup
          className={style['beta-popup-callout']}
          width="250px"
          trigger="none"
          direction="bottomleft"
          show
          content={() => <span>{hint}</span>}
        >
          <div className={style['beta-popup-anchor']}></div>
        </Popup>
      ) : null}
      {children}
    </div>
  )
}

HintRow.propTypes = { hint: PropTypes.string, className: PropTypes.string, children: PropTypes.node }

HintRow.displayName = 'HintRow'

// Paywall upsell shared by the "available" (purchasable) and "locked" (off) states —
// both point at the backend-supplied checkout URL (/checkout/skipper-report via
// onPackage.upgradeURL). Renders nothing when no package is set, so it is a safe
// no-op until the monetization payload lands. The purchase waits for fielding exactly as
// generation does, so while the survey is still in field the link carries no destination.
const UnlockLink = ({ onPackage, isSurveyCompleted, className }) => {
  if (!onPackage?.upgradeURL) return null

  const label = (
    <>
      <i className="icon-aytmfd-skipper" />
      {onPackage.text || UNLOCK_BUTTON_FALLBACK_LABEL}
    </>
  )
  const buttonClassName = 'p-component p-button p-button-rounded p-button-stat'

  return (
    <HintRow hint={isSurveyCompleted ? null : PURCHASE_IN_FIELD_TOOLTIP} className={className}>
      {isSurveyCompleted ? (
        <a className={buttonClassName} href={onPackage.upgradeURL} rel="noreferrer">
          {label}
        </a>
      ) : (
        <span className={`${buttonClassName} p-disabled`} aria-disabled="true">
          {label}
        </span>
      )}
    </HintRow>
  )
}

UnlockLink.propTypes = { onPackage: PropTypes.object, isSurveyCompleted: PropTypes.bool, className: PropTypes.string }

UnlockLink.displayName = 'UnlockLink'

export default UnlockLink
